// batch AI generation videos page
import i18n from '@/translations/lang'
import aiworkflowApi from '@/services/aiworkflowApi'
import Dexie from 'dexie'
import Storage from '@/utils/Storage'

export default {
  data() {
    return {
      isFolderSelected: false,
      selectedFoldersIds: [],
      selectedVideosIds: [],
      childFoldersIds: [],
      loadingText: '',
      loadingInterval: null,
      dotCount: 0,
      folderId_mxn: '',
      updateFlagsInterval: null,
      loopingCount: 0,
      batchGeneratingIds: [],
      isTabActive: true,
      generatingIdsInThisFolder: [],
      isComponentActive: true,
      errorGeneratingIds: null,
      showTooltip: false,
      mouseOverTooltip: false,
      rowId: false,
      rowIndex: 0,
    }
  },
  mounted() {
    if (!window.db.AI_batch_queue) {
      this.initializeDB()
    }
    this.loopingControl()
    this.startUpdateFlagsInterval()

    this.$root.$emit('processQueue')
    this.$root.$on('fetchQueueStatus', () => {
      this.batchLoading()
      this.loopingControl()
    })
    this.$root.$on('updateGeneratingIds', (id) => {
      this.generatingIdsInThisFolder.push(id)
    })
    this.folderId_mxn = this.$route.params.id
    document.addEventListener(
      'visibilitychange',
      this.handleBatchVisibilityChange
    )
    this.verifyIfHasError()
    this.$root.$on('verifyIfHasError', () => {
      this.verifyIfHasError()
    })
  },
  beforeDestroy() {
    this.$root.$off('fetchQueueStatus')
    this.$root.$off('updateGeneratingIds')
    document.removeEventListener(
      'visibilitychange',
      this.handleBatchVisibilityChange
    )
    clearInterval(this.loadingInterval)
    clearInterval(this.updateFlagsInterval)

    this.isComponentActive = false
  },
  computed: {
    checkStatus() {
      return (row) => {
        if (
          !this.generatingIdsInThisFolder ||
          !this.generatingIdsInThisFolder.length
        )
          return false

        const queueing = this.generatingIdsInThisFolder.includes(row.id)
        return queueing
      }
    },
    checkError() {
      return (row) => {
        if (!this.errorGeneratingIds || !this.errorGeneratingIds.length)
          return false

        const error = this.errorGeneratingIds.includes(row.id)
        return error
      }
    },
    handleTooltipPosition() {
      return this.rowIndex >= 7
    },
  },
  watch: {
    selectedItems: function (val) {
      if (val.length) {
        this.checkIfFolderSelected()
      }
    },
    showMenu: function (val) {
      if (val && this.selectedItems.length) {
        this.handleSelectedItems()
      }
    },
    $route: function (route) {
      if (route.name === 'Folders') {
        const {
          params: { id },
        } = route
        this.folderId_mxn = id
      }
      if (route.name === 'Videos') {
        this.folderId_mxn = 'root'
      }
      this.updateFinishedVideos()
      this.startUpdateFlagsInterval()
      this.checkVideosInfolders()
      this.updateVideosInThisFolder()
      this.verifyIfHasError()
    },
    isTabActive: function (val) {
      if (val) this.loopingControl()
      if (!val) clearInterval(this.updateFlagsInterval)
    },
  },
  methods: {
    handleOpenDubModal() {
      if (!this.selectedItems.length) return
      this.$root.$emit('openBatchDubModal')
    },
    handleOpenSubModal() {
      if (!this.selectedItems.length) return
      this.$root.$emit('openBatchSubModal')
    },
    async handleSelectedVideosConfig(selectedVideos) {
      const promises = selectedVideos.map((videoId) =>
        this.getVideoConfig(videoId)
      )
      const configuredVideos = await Promise.all(promises)
      this.$root.$emit('handleBatchConfigs', configuredVideos)
      this.$root.$emit('loadingConfigs', false)
    },
    async getVideoConfig(videoId) {
      const data = await window.db.videos.where({ id: videoId }).first()
      return this.handleVideoConfig(data)
    },
    handleVideoConfig(video) {
      if (!video.config) video.config = {}
      if (!video.config?.bookMarks) video.config.bookMarks = []
      if (!video.config?.subtitles) video.config.subtitles = []
      if (!video.config?.audios) video.config.audios = []
      if (!video?.audios) video.audios = []
      if (!video?.subtitles) video.subtitles = []
      return video
    },
    async updateVideoConfig(video) {
      this.UPDATE_VIDEO(video)
      await window.db.videos.update(video.id, video)
      this.$root.$emit('updateVideosPage', video)
      return
    },
    checkIfFolderSelected() {
      this.isFolderSelected = false
      this.selectedFoldersIds = []
      this.selectedVideosIds = []
      this.selectedItems.forEach((item) => {
        if (!item.hasOwnProperty('video_player')) {
          this.isFolderSelected = true
          this.selectedFoldersIds.push(item.id)
          this.checkIfHasChildFolders(this.mainFolders, item.id)
        } else {
          this.selectedVideosIds.push(item.id)
        }
      })
    },
    async getVideosIdsInFolders() {
      try {
        const promises = this.selectedFoldersIds.map((folderId) =>
          window.db.videos
            .where({ folder_id: folderId, status: 'CONVERTED' })
            .toArray()
        )
        const foldersData = await Promise.all(promises)

        const folderVideosIds = foldersData.flatMap((item) =>
          item.map((video) => video.id)
        )
        return folderVideosIds
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async handleSelectedItems() {
      this.$root.$emit('loadingConfigs', true)
      let folderVideosIds = []

      if (this.isFolderSelected) {
        this.selectedFoldersIds = [
          ...this.selectedFoldersIds,
          ...this.childFoldersIds,
        ]
        folderVideosIds = await this.getVideosIdsInFolders()
      }

      const allVideosIds = [...folderVideosIds, ...this.selectedVideosIds]

      this.$root.$emit('batchAllVideosCount', allVideosIds.length)
      await this.handleSelectedVideosConfig(allVideosIds)
    },
    checkIfHasChildFolders(allFolders, folderId) {
      let childFoldersIds = []

      function findChildFolders(currentFolderId) {
        const foldersWithParent = allFolders.filter(
          (folder) => folder.parent_folder_id === currentFolderId
        )

        for (let folder of foldersWithParent) {
          childFoldersIds.push(folder.id)
          findChildFolders(folder.id)
        }
      }

      findChildFolders(folderId)
      this.childFoldersIds = childFoldersIds
    },
    batchLoading() {
      let loadingText = i18n.t('message.ai.loadingText')
      this.loadingText = loadingText

      this.dotCount = 0

      if (this.loadingInterval) {
        clearInterval(this.loadingInterval)
      }

      this.loadingInterval = setInterval(() => {
        this.dotCount = (this.dotCount + 1) % 4
        this.loadingText = loadingText + '.'.repeat(this.dotCount)
      }, 300)
    },
    async fetchQueueStatus() {
      const folderId = this.folderId_mxn
      const path = this.$route.path
      try {
        let statusData = []

        if (path === '/videos') {
          const { data } = await aiworkflowApi.getDataByFolderId('root')
          statusData = data
        } else {
          const { data } = await aiworkflowApi.getDataByFolderId(folderId)
          statusData = data
        }
        return statusData
      } catch (error) {
        console.error('Error on fetching status', error)
        return false
      }
    },
    async handleQueue() {
      this.checkVideosInfolders()
      this.startUpdateFlagsInterval()
      const statusData = await this.fetchQueueStatus()
      if (!statusData) return
      let uniqueQueueingIds = new Set()

      statusData.forEach((queue) => {
        if (
          queue.status !== 'ERROR' &&
          queue.status !== 'FINISHED' &&
          queue.status !== 'SKIPPED'
        ) {
          uniqueQueueingIds.add(queue.video_id)
        }
      })
      await this.handleErrors(statusData)
      this.updateQueue(uniqueQueueingIds)
    },
    async handleErrors(statusData) {
      const generatingQueue = await window.db.AI_batch_queue.where({
        status: 'generating',
      }).toArray()

      const generatingIds = generatingQueue.flatMap((obj) => {
        const ids = [obj.metadata.id]
        if (obj.metadata.dependent_works.length) {
          ids.push(...obj.metadata.dependent_works)
        }
        return ids
      })

      const errorData = statusData.filter(
        (data) =>
          generatingIds.includes(data.id) &&
          (data.status === 'ERROR' || data.status === 'SKIPPED')
      )
      const uniqueErrorIds = new Set(errorData.map((err) => err.video_id))

      for (const errorId of uniqueErrorIds) {
        try {
          const indexedDbIdsToUpdate = await window.db.AI_batch_queue.where(
            'video_id'
          )
            .equals(errorId)
            .toArray()

          for (const { id } of indexedDbIdsToUpdate) {
            await window.db.AI_batch_queue.update(id, { status: 'error' })
          }
        } catch (error) {
          console.error(
            `Error updating database for errorId ${errorId}:`,
            error
          )
        }
      }
      this.errorGeneratingIds = [...uniqueErrorIds]
    },
    async verifyIfHasError() {
      const errorQueue = await window.db.AI_batch_queue.where({
        status: 'error',
      }).toArray()

      let errorIds = errorQueue.map((err) => err.video_id)
      this.errorGeneratingIds = errorIds
    },
    async handleErrorQueue(row) {
      this.rowId = null
      const videoId = row.id
      const errorQueue = await window.db.AI_batch_queue.where('video_id')
        .equals(videoId)
        .first()
      await window.db.AI_batch_queue.delete(errorQueue.id)
      this.verifyIfHasError()
    },
    handleShowTooltip(row, scope) {
      this.rowIndex = scope.index
      this.rowId = row.id
    },
    handleShowTooltipIndex(row) {
      return this.rowId === row.id
    },
    checkMouseLeave() {
      setTimeout(() => {
        if (!this.mouseOverTooltip) {
          this.rowId = null
        }
      }, 100)
    },
    async updateQueue(queueingIds) {
      const generatingItems = await window.db.AI_batch_queue.where({
        status: 'generating',
      }).toArray()

      generatingItems.forEach(async (item) => {
        const isFinished = !queueingIds.has(item.video_id)
        const isInThisFolder = item.folder_id === this.folderId_mxn
        if (isFinished && isInThisFolder) {
          await window.db.AI_batch_queue.update(item.id, {
            status: 'finished',
          })
        } else if (isFinished && !isInThisFolder) {
          await window.db.AI_batch_queue.update(item.id, {
            status: 'toUpdate',
          })
        }
      })
    },
    async loopingControl() {
      this.checkVideosInfolders()
      // eslint-disable-next-line no-unused-vars
      let queue
      let delay = 20000
      let loopCount = 0
      let maxLoops = 50
      while (
        (queue = await window.db.AI_batch_queue.where({
          status: 'generating',
        }).first())
      ) {
        loopCount++
        if (loopCount === maxLoops) {
          delay += delay
          maxLoops += 50
        }
        if (!this.isTabActive) {
          break
        }
        if (!this.isComponentActive) {
          break
        }
        await new Promise((resolve) => setTimeout(resolve, delay))
        await this.handleQueue()
      }
    },
    async updateVideosInThisFolder() {
      const videosInThisFolder = await window.db.videos
        .where({
          folder_id: this.folderId_mxn,
        })
        .toArray()
      const videosIdsInThisFolder = videosInThisFolder.map((v) => v.id)
      const toUpdateItems = await window.db.AI_batch_queue.where({
        status: 'toUpdate',
      }).toArray()

      toUpdateItems.forEach(async (item) => {
        const isItemInFolder = videosIdsInThisFolder.includes(item.video_id)
        if (isItemInFolder) {
          await window.db.AI_batch_queue.update(item.id, {
            status: 'finished',
          })
        }
      })

      const finishedItems = await window.db.AI_batch_queue.where({
        status: 'finished',
      }).toArray()

      finishedItems.forEach((item) => {
        const isItemInFolder = videosIdsInThisFolder.includes(item.video_id)
        if (isItemInFolder) {
          this.updateVideoList(item)
        }
      })
    },
    async updateVideoList(obj) {
      const dubbing = obj.type === 'dubbing' ? true : false
      const video_id = obj.video_id
      const langs = obj.config.selectedItems.map((item) => item.srclang)
      const videoConfig = await window.db.videos
        .where({
          id: video_id,
        })
        .first()
      if (dubbing) {
        if (!videoConfig.audios) videoConfig.audios = []
        langs.forEach((lang) => videoConfig.audios.push(lang))
      } else {
        if (!videoConfig.subtitles) videoConfig.subtitles = []
        langs.forEach((lang) => videoConfig.subtitles.push(lang))
      }
      await this.updateVideoConfig(videoConfig)
      await window.db.AI_batch_queue.delete(obj.id)
    },
    async updateFinishedVideos() {
      this.checkVideosInfolders()
      const queue = await window.db.AI_batch_queue.toArray()
      const hasQueue = !queue.length ? false : true

      const finishedItems = queue.filter(
        (item) =>
          item.status === 'finished' && item.folder_id === this.folderId_mxn
      )
      const hasFinishedItems = !finishedItems.length ? false : true

      if (hasQueue && hasFinishedItems) {
        this.updateVideosInThisFolder()
      } else {
        this.stopUpdateFlagsInterval()
      }
    },
    startUpdateFlagsInterval() {
      if (this.updateFlagsInterval !== null) this.stopUpdateFlagsInterval()
      this.updateVideosInThisFolder()
      this.updateFlagsInterval = setInterval(async () => {
        await this.updateFinishedVideos()
      }, 4000)
    },
    stopUpdateFlagsInterval() {
      clearInterval(this.updateFlagsInterval)
      this.updateFlagsInterval = null
    },
    async checkVideosInfolders() {
      this.batchLoading()
      const queue = await window.db.AI_batch_queue.toArray()
      const finishedItems = queue.filter(
        (item) =>
          item.status === 'generating' && item.folder_id === this.folderId_mxn
      )
      const ids = finishedItems.map((item) => item.video_id)
      this.generatingIdsInThisFolder = ids
    },
    handleBatchVisibilityChange() {
      this.isTabActive = !document.hidden
    },
    initializeDB() {
      const userId = this.$store.state.user.userInfo?.sub ?? this.getSubKey()
      const dbName = `panda-${userId}`

      window.db = new Dexie(dbName)

      window.db.version(3).stores({
        videos: '++id, video_external_id, folder_id, status',
        AI_batch_queue: '++id, video_id, status',
      })
    },
    getSubKey() {
      let subKey = null
      let keys = Storage.getStorageKeys()
      for (let key of keys) {
        if (key[0].includes('LastAuthUser')) {
          subKey = key[1]
        }
      }
      return subKey
    },
  },
}
